module.exports = __webpack_public_path__ + "static/step-3-5816facd7b1db284868d7cfb4caeaa26.png";